const getBaseUrl = () => window.location.origin;

export const APP_BASEURL = getBaseUrl();
export const API_BASEURL = `${APP_BASEURL}/api`;
export const APP_V1_BASEURL = String(
  import.meta.env.VITE_KLUE_V1_BASEURL ||
    import.meta.env.STORYBOOK_APP_KLUE_V1_BASEURL,
);

export const MODE_BASE_URL = String(
  import.meta.env.VITE_MODE_BASE_URL || 'https://app.mode.com',
);

export const MODE_SANDBOX_URL = String(
  import.meta.env.VITE_MODE_SANDBOX_URL || 'https://modesandbox.com',
);

export const APP_HELP_URL = String(
  import.meta.env.VITE_HELP_URL || 'https://help.app.klue.com',
);
export const WHATS_NEW_URL = String(
  import.meta.env.VITE_WHATS_NEW_URL || 'https://help.app.klue.com/what-s-new',
);
export const SLACK_HELP_URL = {
  consumer: import.meta.env.VITE_INTEGRATION_SLACK_HELP_URL_CONSUMER || '',
  curator: import.meta.env.VITE_INTEGRATION_SLACK_HELP_URL_CURATOR || '',
};
export const SLACK_LINK_URL =
  import.meta.env.VITE_INTEGRATION_SLACK_INSTALL_URL || '';
export const KLUE_EMAIL_HELP_URL = {
  consumer: import.meta.env.VITE_INTEGRATION_KLUE_EMAIL_HELP_URL_CONSUMER || '',
  curator: import.meta.env.VITE_INTEGRATION_KLUE_EMAIL_HELP_URL_CURATOR || '',
};
export const KLUE_BUTTON_HELP_URL = {
  consumer:
    import.meta.env.VITE_INTEGRATION_KLUE_BUTTON_HELP_URL_CONSUMER || '',
  curator: import.meta.env.VITE_INTEGRATION_KLUE_BUTTON_HELP_URL_CURATOR || '',
};
export const KLUE_MOBILE_APP_HELP_URL = {
  consumer: import.meta.env.VITE_INTEGRATION_MOBILE_APP_HELP_URL_CONSUMER || '',
  curator: import.meta.env.VITE_INTEGRATION_MOBILE_APP_HELP_URL_CURATOR || '',
};
export const SALESFORCE_HELP_URL = {
  consumer: import.meta.env.VITE_INTEGRATION_SALESFORCE_HELP_URL_CONSUMER || '',
  curator: import.meta.env.VITE_INTEGRATION_SALESFORCE_HELP_URL_CURATOR || '',
};
export const TEAMS_HELP_URL =
  import.meta.env.VITE_INTEGRATION_MS_TEAMS_HELP_URL || '';

export const IOS_APP_URL = import.meta.env.VITE_INTEGRATION_IOS_APP_URL || '';
export const ANDROID_APP_URL =
  import.meta.env.VITE_INTEGRATION_ANDROID_APP_URL || '';
export const CHROME_EXTENSION_URL =
  import.meta.env.VITE_INTEGRATION_CHROME_EXTENSION_URL || '';
export const EDGE_EXTENSION_URL =
  import.meta.env.VITE_INTEGRATION_EDGE_EXTENSION_URL || '';
export const TEAMS_APP_URL =
  import.meta.env.VITE_INTEGRATIONS_MS_TEAMS_URL || '';

export const CONFIGURE_CURATOR_ASSIGNMENTS_URL =
  import.meta.env.VITE_CONFIGURE_CURATOR_ASSIGNMENTS_URL ||
  'https://help.app.klue.com/article/lk2jc7y5hp-assign-curators-to-a-board';

export const DATA_EXPORT_HELP_URL =
  import.meta.env.VITE_INTEGRATION_DATA_EXPORT_HELP_URL ||
  'https://help.app.klue.com/article/h2r8b7ll82';

export const CONTENT_EXPORT_HELP_URL =
  import.meta.env.VITE_CONTENT_EXPORT_HELP_URL ||
  'https://help.app.klue.com/article/zv5zha3hbx';

export const CHAT_CUSTOMIZATION_HELP_URL =
  import.meta.env.VITE_CHAT_CUSTOMIZATION_HELP_URL ||
  `${APP_HELP_URL}/article/mu9qza3a0o-ask-klue-updates-chat-customization-and-sources-for-consumers`;

export const CREATE_AI_BATTLECARD_HELP_URL =
  import.meta.env.VITE_CREATE_AI_BATTLECARD_HELP_URL ||
  `${APP_HELP_URL}/article/5q8idb7hnw-ask-klue-research-mode-prompting-guide#job_creating_a_new_competitor_battlecard`;

export const GONG_SALESFORCE_SUPPORT_URL =
  'mailto:support@klue.com?subject=Requesting%20Sync%20Gong%20Competitor%20Mentions%20to%20Salesforce%20Integration%20Setup';

export const GONG_HUBSPOT_SUPPORT_URL =
  'mailto:support@klue.com?subject=Requesting%20Sync%20Gong%20Competitor%20Mentions%20to%20HubSpot%20Integration%20Setup';

/**
 * "Book my session" on the Klue 2.0 setup landscape step. Points at a
 * third-party scheduling page, so it is env-configurable — whoever runs these
 * working sessions can change without a deploy.
 */
export const HATCH_FINISH_SETUP_LANDSCAPE_SESSION_URL =
  import.meta.env.VITE_HATCH_FINISH_SETUP_LANDSCAPE_SESSION_URL ||
  'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3XDyHA_YkQns4TS6s98UwW6ZaWwlk6-wjdyVOjBxFpMx8_SRwoc_nv3KY4Chq0AWFk9t4d-8Q4';

export const ZOOM_DATA_SYNC_MARKETPLACE_URL =
  import.meta.env.VITE_INTEGRATIONS_ZOOM_DATA_SYNC_MARKETPLACE_URL ||
  'https://marketplace.zoom.us/apps/BDXXGpBiTX2hMAB7SE_vHA';
